import React, { useState } from 'react';
import { useHistory, Redirect, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Layout, Row } from 'antd';
import { Content } from 'antd/lib/layout/layout';
// import { setItem } from "../../util/localStorage"
import { makeStyles } from '@material-ui/core/styles';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { login } from 'src/actions/LoginAction';
import CButton from '../../component/Button';
import { CBody1, CBody2, CTitle } from '../../component/Text';
import { CInput } from '../../component/Input';
// import { authenticate } from "../../services/napi"
import Loader from '../../component/Loader/Loader';

// import { CropLandscapeOutlined } from '@material-ui/icons';
import { divideQueryParams } from '../../util/queryParams';

const useStyles = makeStyles(() => ({
  checkboxLabel: {
    color: '#9BA0AD',
    fontFamily: 'Poppins',
    fontSize: '12px'
  },
  checkboxRoot: {
    '& .MuiSvgIcon-root': {
      fill: '#CAD8FF',
      zIndex: 1
    },
    '&:not($checked) .MuiIconButton-label:after': {
      backgroundColor: 'white',
      content: '""',
      height: 15,
      position: 'absolute',
      width: 15,
      zIndex: 0
    }
  },
  errorMessage: {
    marginTop: '24px'
  },
  ghost: {
    display: 'none'
  },
  root: {
    '& .MuiFormLabel-root': {
      color: '#000000',
      fontFamily: 'Poppins',
      zIndex: 2
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        backgroundColor: 'white',
        borderColor: '#CAD8FF',
        zIndex: -1
      },
      borderRadius: '10px',
      zIndex: 1
    }
  }
}));

const Login = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { state } = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [check, setCheck] = useState(false);
  let idFromUrl;
  let pathname = '/';
  let locationSearch = '';

  const classes = useStyles();
  const loginStore = useSelector(({ login }) => {
    return login;
  });
  // const error = useSelector(({ login }) => login.showError);
  const [errorMessage, setErrorMessage] = useState(false);

  if (state?.from?.search) {
    const paramsObj = divideQueryParams(state.from.search);
    idFromUrl = paramsObj.get('id');
    if (idFromUrl) {
      pathname = state?.from?.pathname;
      locationSearch = state.from.search;
    }
  }

  const onLogin = async (e) => {
    e.preventDefault();
    const redirectPath = idFromUrl ? `${pathname}?id=${idFromUrl}` : '/';

    dispatch(
      login(
        username,
        password,
        () => history.push(redirectPath),
        () => {
          setErrorMessage(true);
        }
      )
    );
  };

  const resetPassword = () => {
    history.push('/reset');
  };

  const isAuthenticated = loginStore.user !== null;
  const { isInitialised } = loginStore;

  if (!isInitialised) {
    return <Loader />;
  }

  if (isAuthenticated) {
    return (
      <Redirect
        to={{
          pathname,
          search: locationSearch,
          state: {}
        }}
      />
    );
  }

  return (
    <>
      <Layout style={{ backgroundColor: 'white', height: '100%' }}>
        <Content>
          <Row align="middle" justify="center" style={{ minHeight: '100vh' }} type="flex">
            <Col align="start" span={6} style={{ maxWidth: '360px' }}>
              <CTitle
                xstyle={{
                  lineHeight: '24px',
                  marginBottom: '12px'
                }}
              >
                Log In
              </CTitle>
              <CBody1
                xstyle={{
                  color: '#9BA0AD',
                  fontSize: '14px',
                  fontWeight: 'small'
                }}
              >
                Don’t have an account?
                <a
                  href="./login"
                  style={{
                    color: '#5564F8',
                    fontWeight: 700,
                    marginLeft: '6px'
                  }}
                >
                  Sign Up
                </a>
              </CBody1>

              <form
                onSubmit={(e) => onLogin(e)}
                style={{
                  backgroundColor: '#F0F4FF',
                  borderRadius: '10px',
                  marginTop: '32px',
                  padding: '40px 24px'
                }}
              >
                <CInput
                  classes={{ root: classes.root }}
                  id="outlined-flexible"
                  label="E-Mail"
                  onChange={(event) => setUsername(event.target.value)}
                  size="small"
                  value={username}
                  variant="outlined"
                  xstyle={{
                    borderRadius: '10px',
                    width: '100%'
                  }}
                />

                <CInput
                  classes={{ root: classes.root }}
                  id="outlined-flexible-2"
                  label="Password"
                  onChange={(event) => setPassword(event.target.value)}
                  size="small"
                  type="password"
                  value={password}
                  variant="outlined"
                  xstyle={{
                    marginTop: '24px',
                    width: '100%'
                  }}
                />

                <FormControlLabel
                  classes={{
                    label: classes.checkboxLabel,
                    root: classes.checkboxRoot
                  }}
                  control={
                    <Checkbox
                      checked={check}
                      color="primary"
                      name="checkedF"
                      onChange={() => {
                        setCheck((c) => !c);
                      }}
                    />
                  }
                  label="Remember me"
                  style={{ margin: '5px 0px 0px -11px' }}
                />

                <CBody2
                  onClick={resetPassword}
                  pointer
                  underline
                  xstyle={{
                    color: '#9BA0AD',
                    float: 'right',
                    fontSize: '12px',
                    marginTop: '16px'
                  }}
                >
                  Forgot Password
                </CBody2>

                <CButton
                  block
                  onClick={onLogin}
                  size="large"
                  type="primary"
                  xstyle={{
                    marginLeft: '0px',
                    marginTop: '20px'
                  }}
                >
                  Log In
                </CButton>
                <input style={{ display: 'none' }} type="submit" />
                <Alert
                  className={errorMessage ? classes.errorMessage : classes.ghost}
                  onClose={() => setErrorMessage(false)}
                  severity="error"
                >
                  <AlertTitle>Error</AlertTitle>
                  Credentials were incorrect. <strong>Try Again</strong>
                </Alert>
              </form>
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );
};

export default Login;
